import { PolymerElement } from "@polymer/polymer/polymer-element.js";
class ControlItem extends PolymerElement {
    static get is() {
        return "control-item";
    }
    static get properties() {
        return {
            component: {
                type: Object,
                value: null,
                notify: true,
                observer: "_elementChanged",
            },
        };
    }
    ready() {
        super.ready();
        console.log("hell yeah");
    }
    _elementChanged() {
        this.$.object.appendChild(this.component);
    }
}
window.customElements.define(ControlItem.is, ControlItem);
//# sourceMappingURL=control-item.js.map